import * as Scrivito from "scrivito";
import MainNavigation from "./MainNavigation";
import Options from "./Options";
import Logo from "./Logo";

function TwoLinesTopNavigation({ currentPage }) {
  return (
    <div className="shadow main-navigation-container bg-white">
      <div className="container navigation">
        <div className="row">
          <div className="col-4 col-sm-3 col-md-2">
            <Logo currentPage={currentPage} />
          </div>
          <div className="col-8 col-sm-9 col-md-10 align-self-center">
            <Options currentPage={currentPage} />
            <MainNavigation currentPage={currentPage} />
          </div>
        </div>
      </div>
    </div>
  );
}
export default Scrivito.connect(TwoLinesTopNavigation);
